import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    status: "fetchingFromColor",
    error: null,
    color: "#03a9f4",
};

const ColorSlice = createSlice({
    name: "color",
    initialState: initialState,

    reducers: {
        SetColor: (state, action) => {
            state.color = action.payload
        },
    },
});

const { SetColor } = ColorSlice.actions;

export default ColorSlice.reducer;

export {
    SetColor
};
